<template>
  <div class="KYCMainVisualStep">
    <div class="KYCMainVisualStep__wrap">
      <Slick :options="slickOptions">
        <div v-for="(step, index) in steps" :key="`${step.step}-${index}`">
          <div class="KYCMainVisualStep__steps">{{ step.step }}</div>
          <div class="KYCMainVisualStep__text">
            <div class="KYCMainVisualStep__title">{{ step.title }}</div>
          </div>

          <div>
            <img
              width="100%"
              :src="
                require(`../../assets/img/kyc_info/img_${step.step}.png?v=1.1`)
              "
            />
          </div>
        </div>
      </Slick>

      <div class="arrow-container">
        <div class="arrow prev">
          <img width="12px" src="~@/assets/img/kyc_info/ic_kyc_arrows.png" />
        </div>
        <div class="arrow next">
          <img width="12px" src="~@/assets/img/kyc_info/ic_kyc_arrows.png" />
        </div>
      </div>
    </div>
    <div class="KYCMainVisualStep__button">
      <a :href="zendeskUrl['ko']['kycInformation']" target="_blank">
        고객확인 절차 가이드 바로가기
      </a>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Slick from "vue-slick";

export default {
  name: "KYCMainVisualStep",
  components: {
    Slick,
  },
  data() {
    return {
      steps: [
        {
          step: "STEP1",
          title: "신원인증 시작",
        },
        {
          step: "STEP2",
          title: "휴대폰/신분증 본인인증",
        },
        {
          step: "STEP3",
          title: "기본정보 입력",
        },
        {
          step: "STEP4",
          title: "필수정보 입력",
        },
        {
          step: "STEP5",
          title: "은행계좌 인증",
        },
        {
          step: "STEP6",
          title: "1원 인증",
        },
        {
          step: "STEP7",
          title: "신원인증 완료",
        },
      ],
      slickOptions: {
        slide: "div",
        infinite: true,
        seed: 100,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        apendArrows: ".arrow-container",
        nextArrow: ".next",
        prevArrow: ".prev",
      },
    };
  },
  computed: {
    ...mapState("Firebase", ["zendeskUrl"]),
  },
};
</script>
<style lang="scss">
@import "slick-carousel/slick/slick.css";
@import "slick-carousel/slick/slick-theme.css";
.slick-slide {
  height: inherit !important;
}

.slick-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: -40px !important;

  & li {
    width: 14px !important;
    height: 14px !important;
  }

  button {
    width: 14px !important;
    height: 14px !important;

    &::before {
      content: "" !important;
      opacity: 1 !important;
      background: #2d375a;
      border-radius: 50%;
      width: 14px !important;
      height: 14px !important;
    }

    &:hover {
      background: transparent;
    }
  }

  .slick-slider {
    margin-bottom: 0 !important;
  }

  & li.slick-active {
    width: 28px !important;
    height: 14px !important;

    & button {
      width: 28px !important;
      height: 14px !important;

      &::before {
        background: #fff;
        width: 28px !important;
        border-radius: 12px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.KYCMainVisualStep {
  width: 100%;
  margin: 80px auto 0 auto;
  text-align: center;
  padding: 0 50px;

  &__wrap {
    width: 260px;
    margin: 0 auto;
    position: relative;
  }

  &__steps {
    font-size: 20px;
    color: #fff;
    font-weight: 300;
  }

  &__text {
    margin-top: 8px;
    margin-bottom: 34px;
  }

  &__title {
    font-size: 24px;
    color: #fff;
    font-weight: 500;
  }

  &__description {
    font-size: 14px;
    margin-top: 5px;
    height: 20px;
  }

  .arrow-container {
    width: 636px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .arrow {
      width: 78px;
      height: 136px;
      background: #141935;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.prev {
        img {
          transform: rotate(-180deg);
        }
      }

      &:hover {
        background: #414664;
      }
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 85px;

    a {
      background: #239bbe;
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
      font-weight: 300;
      border-radius: 8px;

      &:hover {
        background: #1978a0;
      }
    }
  }
}
</style>
